import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "bg-light mb-2 mt-3 py-1 px-2 shadow-sm rounded" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_MobileLikeNavHeader = _resolveComponent("MobileLikeNavHeader");
    const _component_PrincipalMenu = _resolveComponent("PrincipalMenu");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_MobileLikeNavHeader, {
            title: "Meus Dados",
            height: "100px",
            "go-back-url": "/restrito#/"
        }),
        _createVNode(_component_PrincipalMenu, { menus: _ctx.menus }, null, 8, ["menus"])
    ]));
}
